import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'
import box from '../BoxSlice'
import Container from '../../../components/Container'
import Title from '../../../components/Title'
import WysiwygOutput from '../../../components/WysiwygOutput'
import ProductCell from '../../Products/components/ProductCell'
import Image from '../../../components/Image'

export default function Box() {
  const items = useSelector(box.getBox) || []

  return (
    <StyledBoxWrap>
      <Container>
        <StyledBoxContainer>
          <StyledBoxGrid>
            <StyledBoxCell>
              <StyledRecipesTitle>
                <Title>RAMEN BOX</Title>
              </StyledRecipesTitle>

              <StyledRecipesDescription>
                <WysiwygOutput>
                  <p>
                    Разновидностей рамена — сотни: почти в каждом регионе Японии
                    существует свой вариант этого блюда. Но всё же есть
                    несколько главных общих правил, по которым его готовят.
                  </p>

                  <h4>Бульон</h4>

                  <p>
                    Основой бульона для рамена могут быть кости животных и птиц
                    (свинина, курица, говядина), свежая рыба или более лёгкие
                    ингредиенты — морские водоросли, сушёные морепродукты,
                    овощи, грибы. В бульон добавляют различные ароматные
                    приправы: лук, чеснок, имбирь или сушёные грибы.
                  </p>

                  <h4>Добавки</h4>

                  <p>
                    Добавки в рамен просто необходимы. Это могут быть простые
                    овощи и приправы, мясо и соусы, которые готовят заранее.
                    Например, в Японии популярна свинина тясю (приготовленная в
                    особом соусе), соленья, ферментированные побеги бамбука,
                    грибы шиитаки, зелёный лук, шпинат, китайская капуста, нори,
                    варёные яйца.
                  </p>
                </WysiwygOutput>
              </StyledRecipesDescription>
            </StyledBoxCell>

            <StyledBoxCell>
              <StyledProductTop>
                <Image
                  responsive
                  width={400}
                  height={400}
                  alt="img"
                  src={require('../../../assets/images/box.jpg')}
                />
              </StyledProductTop>

              <StyledProductDesc>
Состоит один Ramen Box из двух блюд на Ваш выбор. Вы можете выбрать как одинаковые блюда в один Ramen Box, так и разные.<br />
В составе:
<ul>
<li>готовый бульон с ароматными маслами и таре, который нужно довести до кипения;</li>
<li>свежая лапша, которую нужно отварить;</li>
</ul>
Начинка - добавки, которые нужно подогреть.<br />
Весь процесс займет у Вас до 10 минут.

              </StyledProductDesc>
            </StyledBoxCell>

            {items.map((item) => (
              <StyledBoxCell key={item.id}>
                <ProductCell item={item} />
              </StyledBoxCell>
            ))}
          </StyledBoxGrid>
        </StyledBoxContainer>
      </Container>
    </StyledBoxWrap>
  )
}

Box.defaultProps = {}

Box.propTypes = {}

const StyledProductTop = styled.div``
const StyledProductDesc = styled.div`
  font-size: 18px;
  line-height: 130%;
  color: #000000;
  padding-top: 20px;
`

const StyledBoxWrap = styled.div`
  padding-top: 100px;
  padding-bottom: 70px;

  ${up('md')} {
    padding-top: 100px;
    padding-bottom: 70px;
  }

  ${up('lg')} {
    padding-top: 120px;
    padding-bottom: 90px;
  }

  ${up('xl')} {
    padding-top: 170px;
    padding-bottom: 100px;
  }
`

const StyledRecipesDescription = styled.div``

const StyledRecipesTitle = styled.div`
  margin-bottom: 18px;

  ${up('md')} {
    margin-bottom: 22px;
  }

  ${up('xl')} {
    margin-bottom: 38px;
  }
`

const StyledBoxContainer = styled.div`
  overflow: hidden;
`

const StyledBoxGrid = styled.div`
  margin: -20px -12px;

  ${up('sm')} {
    display: flex;
    flex-wrap: wrap;
  }

  ${up('lg')} {
    margin: -25px -12px;
  }

  ${up('xl')} {
    margin: -32px -20px;
  }
`

const StyledBoxCell = styled.div`
  padding: 20px 12px;

  ${up('sm')} {
    width: 50%;
  }

  ${up('md')} {
    width: 33.333333%;
  }

  ${up('lg')} {
    padding: 25px 12px;
  }

  ${up('xl')} {
    padding: 32px 20px;
  }
`
